import "ngstorage";

import {TRIGGER_NEXT_EVENT_NAME, UPDATE_WORKFLOW_EVENT_NAME, WALKTHROUGH_STATES, DRESS_CODE_DEFAULT} from "./variables";

const GRACE_PERIOD = 1000 * 60 * 60 * 24 * 3;

class PostAShiftWalkThroughController {
  constructor(
    $localStorage,
    $scope,
    $rootScope,
    $state,
    $stateParams,
    AuthService,
    EnvService,
    SecurityService,
    $timeout,
    TrackingService,
    events,
    ngProgressFactory,
    $location,
    companies
  ) {
    this.name = "postashiftwalkthrough";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$localStorage = $localStorage;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$progress = ngProgressFactory.createInstance();
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.$tracking = TrackingService;
    this.$events = events;
    this.$location = $location;
    this.$companies = companies;

    this.getJobbleTypes().then((types) => {
      this.warehouse_jobble_type = this.findWarehouseJobType(types);
      this.$rootScope.warehouse_jobble_type = this.warehouse_jobble_type;

      this.remote_jobble_type = this.findRemoteJobType(types);
      this.$rootScope.remote_jobble_type = this.remote_jobble_type;

      this.event_jobble_type = this.findEventJobType(types);
      this.$rootScope.event_jobble_type = this.event_jobble_type;

      console.log("WE HAVE SET REMOTE TYPE");
    });

    this.group1State = true;
    this.group2State = true;
    this.group3State = true;
    this.currentUser = this.$auth.getUserData();

    this.walkthroughStates = WALKTHROUGH_STATES;
    this.walkthroughState = this.walkthroughStates.POSITION;
    //this.walkthroughState = this.walkthroughStates.DATEANDTIME;
    //this.walkthroughState = this.walkthroughStates.PAY;

    this.$rootScope.$emit(TRIGGER_NEXT_EVENT_NAME, {
      walkthroughState: this.walkthroughState,
    });

    this.GoNextListener = this.$rootScope.$on(TRIGGER_NEXT_EVENT_NAME, ($event, params) => {
      this.handleGoNext(params.walkthroughState);
    });

    this.UpdateListener = this.$rootScope.$on(UPDATE_WORKFLOW_EVENT_NAME, ($event, params) => {
      this.setValidStates();
    });

    this.LockLeftPanelListener = this.$rootScope.$on("LockLeftPanel", ($event, params) => {
      this.disableAllowedLinks();
    });

    this.UnLockLeftPanelListener = this.$rootScope.$on("UnLockLeftPanel", ($event, params) => {
      this.enableAllowedLinks();
    });

    this.SendToDateTimeListener = this.$rootScope.$on("SendToDateTime", ($event, params) => {
      if (this.event.is_long_term) {
        console.log("Done syncing with the API after event cloning in PAJ Controller", this.event);
        this.$timeout(() => {
          this.setWalkthroughState(WALKTHROUGH_STATES.DATEANDTIME);
        }, 100);
      } else {
        this.$timeout(() => {
          this.setWalkthroughState(WALKTHROUGH_STATES.DATEANDTIME);
        }, 100);
      }
    });

    this.$scope.$on("$destroy", this.SendToDateTimeListener);
    this.$scope.$on("$destroy", this.UnLockLeftPanelListener);
    this.$scope.$on("$destroy", this.LockLeftPanelListener);
    this.$scope.$on("$destroy", this.GoNextListener);
    this.$scope.$on("$destroy", this.UpdateListener);

    this.event = {
      location: {},
      shifts: [this.getNewShiftObject()],
      openings: null,
      position_type: null,
      shift_title: null,
      company_info: null,
      shift_description: null,
      hiring_manager: this.$auth.getUserData().id,
      requirements: [],
      questions: [],
      hourly_rate: null,
      is_w2: null,
      dress_code: null,
      company_name: this.$auth.getUserData().company.name,
      company_img: this.$auth.getUserData().company.companyLogoUriFree || "/app/vendor/images/events_placeholder_jobble.png",
      remote_job: false,
      is_long_term: true,
      numberOfWeeksToScheduleJob: "11",
    };

    this.valid = {
      openings: false,
    };
    this.allowed = {
      openings: false,
    };

    this.development_env = this.$env.getEnv();
    console.log("this.development_env", this.development_env);
  }

  $onInit() {
    localStorage.savingDescription = false;
    localStorage.savingQuestions = false;

    this.setCompanyLogo();

    this.getJobbleTypes().then((types) => {
      this.warehouse_jobble_type = this.findWarehouseJobType(types);
      this.$rootScope.warehouse_jobble_type = this.warehouse_jobble_type;

      this.remote_jobble_type = this.findRemoteJobType(types);
      this.$rootScope.remote_jobble_type = this.remote_jobble_type;

      this.event_jobble_type = this.findEventJobType(types);
      this.$rootScope.event_jobble_type = this.event_jobble_type;
    });

    if (!this.$location || !this.$timeout) return console.error("Fatal error: The post a job flow was not initialized correctly.");

    if (this.$location.$$search.eid) {
      this.$timeout(() => {
        this.event.id = this.$location.$$search.eid;
        this.syncEventWithApi(this.event.id, false);
      });
    }

    if (this.$location.$$search.cid) {
      this.$timeout(() => {
        const clonedFrom = this.$location.$$search.cid;
        this.event.clonedFrom = parseFloat(clonedFrom);
        this.cloneEventv3(clonedFrom);
        //
        //this.syncEventWithApi(clonedFrom, true);
      });
    }

    this.setValidStates();

    this.getCompanyUsers();
    //this.setAutoHireToggle();
  }

  setCompanyLogo() {
    console.log("setCompanyLogo");
    console.dir(this.currentUser);
  }

  setAutoHireToggle() {
    //check to see if company has auto hire on
    this.$timeout(() => {
      $(".switch").trigger("click");
    });
  }

  cloneEventv3(eventId) {
    this.$events.cloneEventv3(eventId).then(
      (response) => {
        console.log("cloned event v3");
        console.dir(response);
        this.syncEventWithApi(response.data.eventId, false);
      },
      function (error) {
        console.log("error from cloning endpoint");
        console.dir(error);
      }
    );
  }

  getCompanyDesc(eventId) {
    this.$events.getEventCompanyDescription().then((data) => {
      this.event.company_info = data.data.company.description;
      this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});
      //this.setValidStates();
    });
  }

  getReq(eventId) {
    this.$events.getShiftRequirements(eventId).then((data) => {
      this.event.requirements = data.data;
      this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});
      //this.setValidStates();
    });
  }

  syncEventWithApi(eventId, isClone) {
    if (!eventId) return console.warn("Trying to sync event without an event id");

    this.setLoader();
    this.disableAllowedLinks();
    this.getCompanyDesc(eventId);
    this.getReq(eventId);

    this.$events.getEventByIdWithFields(eventId, 1).then((data) => {
      const event = data.data;
      this.$timeout(() => {
        this.updateEventFromApi(event, isClone);
        this.enableAllowedLinks();
      }, 200);
    });
  }

  enableAllowedLinks() {
    console.log("enableAllowedLinks");
    console.dir(this.allowed);
  }

  disableAllowedLinks() {
    console.log("disableAllowedLinks");
    console.dir(this.allowed);
    this.$timeout(() => {
      $(".post-a-shift-container .main-next-button").addClass("disabled");
    });
    //allowed {"openings":true,"position_type":true,"location":true,"shifts":-71.05228,"shift_title":true,"company_info":true,"shift_description":true,"arrival_instructions":true,"dress_code":true,"requirements":true,"hiring_manager":true,"hourly_rate":true}
  }

  setLoader() {
    this.$timeout(() => {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    this.$timeout(() => {
      $("html").removeClass("wait");
    });
  }

  updateEventFromApi(event, isClone) {
    const deduppedJobble = event.subEvents[0].deduppedJobbles[0];
    this.event.openings = event.numberOfOpenings;
    this.event.position_type = deduppedJobble.jobbleType.id + "";
    if (this.$rootScope.remote_jobble_type) {
      this.event.remote_job = deduppedJobble.jobbleType.id === this.$rootScope.remote_jobble_type.id;
    } else {
      //this.event.remote_job = deduppedJobble.jobbleType.id === this.$rootScope.remote_jobble_type.id;
    }
    this.event.dress_code = deduppedJobble.dressCode;
    this.event.arrival_instructions = event.arrivalInstructions;
    this.event.deduppedJobbleId = event.subEvents[0].deduppedJobbles[0].id;
    this.event.onsite_manager_name = event.onsiteManagerName;
    this.event.onsite_manager_number = event.onsiteManagerNumber;
    this.event.is_long_term = event.isLongTerm;
    this.event.numberOfWeeksToScheduleJob = event.weeks + "";
    this.event.shift_title = event.name;
    this.event.is_w2 = event.isW2;
    this.eraseDefaultName();
    this.event.shift_description = event.description;
    this.event.questions = event.surveyQuestions;
    this.event.hiring_manager = deduppedJobble.manager.id;
    this.event.back_end_loaded = true;
    this.event.id = event.id;

    console.log(this.$rootScope.remote_jobble_type, this.event);

    if (this.$rootScope.warehouse_jobble_type && this.$rootScope.warehouse_jobble_type.id) {
      if (this.$rootScope.warehouse_jobble_type.id + "" === this.event.position_type + "") {
        //this.event.is_long_term = true;
        //this.event.forced_long_term = true;
      }
    }

    if (this.$rootScope.event_jobble_type && this.$rootScope.event_jobble_type.id) {
      if (this.$rootScope.event_jobble_type.id + "" === this.event.position_type + "") {
        this.event.is_long_term = false;
        this.event.forced_one_time = true;
      }
    }

    const currentUser = this.$auth.getUserData();
    const rate = currentUser.company.defaultPlan.jobblerFeePct;
    let payPerHour = deduppedJobble.payPerHour;
    const epi = 0.00001;

    let p = 100 - rate * 100;
    payPerHour = (payPerHour * p) / 100 / 100;

    this.event.hourly_rate = Math.round((payPerHour + epi) * 100) / 100;

    this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});

    this.calculateCosts();
    this.processShiftsFromApi(deduppedJobble, isClone);
    //this.setValidStates();

    this.unSetLoader();
  }

  calculateCosts() {
    if (!this.event) return;

    const currentUser = this.$auth.getUserData();
    const rate = currentUser.company.defaultPlan.jobblerFeePct;

    const pay = parseFloat(this.event.hourly_rate);
    const epi = 0.00001;
    const cost = Math.round((pay + epi) * 100 * (1 + rate)) / 100;

    this.$timeout(() => {
      this.platform_cost = cost;
      this.platform_rate = Math.round(100 * (rate + epi) * 100) / 100;
      this.platform_fee = Math.round((cost - pay) * 100) / 100;
    });

    if (this.event.shifts && this.event.shifts.length) {
      let hours = 0;

      this.event.shifts.forEach((shift) => {
        if (!shift) return;

        const startDate = new Date(`${shift.startDate} ${shift.startTime}`);
        const endDate = new Date(`${shift.endDate} ${shift.endTime}`);

        hours += (endDate.getTime() - startDate.getTime()) / 1000 / 60 / 60;
      });

      this.$timeout(() => {
        this.total_hours = hours;
        this.estimated_cost = Math.round((cost + epi) * 100 * hours * parseFloat(this.event.openings)) / 100;
      });
    }
  }

  go_to_bulk_upload_jobs_page() {
    this.$state.go("postjobbulk");
  }

  eraseDefaultName() {
    if (this.event && this.event.shift_title === "DEFAULT_EVENT_TITLE") {
      this.event.shift_title = "";
    }
  }

  getCloneShiftOffset(shifts) {
    if (!shifts || !shifts.length) return 1;

    let earliestShift = null;
    let earliestShiftTime = null;

    shifts.map((shift) => {
      let startTime = moment(shift.timeInterval.startTime);
      let startTimeValue = startTime.valueOf();

      if (!earliestShiftTime) {
        earliestShiftTime = startTimeValue;
        earliestShift = shift;
      } else {
        if (startTimeValue < earliestShiftTime) {
          earliestShiftTime = startTimeValue;
          earliestShift = shift;
        }
      }
    });

    const today = moment();
    const shiftDate = moment(earliestShift.timeInterval.startTime);

    const diff = moment.duration(today.diff(shiftDate));

    let offset = Math.abs(Math.ceil(diff.asWeeks()));

    console.log("preoffset", offset, shiftDate, today);

    if (shiftDate.valueOf() > today.valueOf() || offset === 0) offset = 1;

    return offset;
  }

  processShiftsFromApi(deduppedJobble, isClone) {
    let offset = 1;

    if (isClone) {
      offset = this.getCloneShiftOffset(deduppedJobble.shifts);
      console.log("Cloning Offset", offset);
    }

    let shifts = deduppedJobble.shifts.map((shift) => {
      this.event.contactInfo = shift.contactInfo;

      let startTime = moment(shift.timeInterval.startTime);
      let endTime = moment(shift.timeInterval.endTime);

      if (isClone) {
        startTime = startTime.add(offset, "weeks");
        endTime = endTime.add(offset, "weeks");
      }

      const newShift = {
        id: shift.id,
        startDate: startTime.format("MM/DD/YYYY"),
        endDate: endTime.format("MM/DD/YYYY"),
        startTime: startTime.format("h:mm a").toUpperCase(),
        endTime: endTime.format("h:mm a").toUpperCase(),
        overnight: shift.overnight,
        contactInfo: shift.contactInfo,
        unpaidBreak: shift.unpaidBreak,
        hasUnpaidBreak: shift.unpaidBreak > 0,
      };

      console.log("New Shift", newShift);

      if (isClone) {
        delete newShift.id;
      }

      return newShift;
    });

    console.log("These are the shifts", shifts);

    shifts = shifts.sort((a, b) => {
      return new Date(`${a.startDate} ${a.startTime}`).getTime() - new Date(`${b.startDate} ${b.startTime}`).getTime();
    });

    this.$events.adjustTimeZone(this.event.contactInfo.zipCode).then(({timeZone, timeZoneDifference}) => {
      this.$timeout(() => {
        this.event.shifts = shifts.map((shift) => {
          let {startTime, endTime} = this.$events.adjustTimeZones(shift, timeZone, timeZoneDifference, true);

          startTime = moment(startTime);
          endTime = moment(endTime);

          const newShift = {
            id: shift.id,
            startDate: startTime.format("MM/DD/YYYY"),
            endDate: endTime.format("MM/DD/YYYY"),
            startTime: startTime.format("h:mm a").toUpperCase(),
            endTime: endTime.format("h:mm a").toUpperCase(),
            overnight: shift.overnight,
            contactInfo: shift.contactInfo,
            unpaidBreak: shift.unpaidBreak,
            hasUnpaidBreak: shift.unpaidBreak > 0,
          };

          if (isClone) {
            delete newShift.id;
          }

          return newShift;
        });

        this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});

        if (isClone) {
          this.cloneNewEvent(this.event.shifts);
        } else {
          this.$rootScope.$emit("PostAJobGlobalApiSync", {event: this.event});
          this.unSetLoader();
          this.setValidStates(true);
          /*
                    this.$timeout(() => {
                        this.$rootScope.$emit("PostAJobGlobalApiSyncLongTerm", {event: this.event});
                    }, 500);
                    */
        }
      });
    });
  }

  cloneNewEvent(shifts) {
    console.log("cloneNewEvent");
    console.dir(this.event);

    this.setLoader();
    this.$events.adjustTimeZone(this.event.contactInfo.zipCode).then(({timeZone, timeZoneDifference}) => {
      const timeIntervalsArray = shifts.map((shift) => {
        let {startTime, endTime} = this.$events.adjustTimeZones(shift, timeZone, timeZoneDifference, false);

        console.log("contactInfo", JSON.stringify(this.event.contactInfo));

        let contactInfo = JSON.parse(JSON.stringify(this.event.contactInfo));
        delete contactInfo["id"];

        return {
          contactInfo: contactInfo,
          startDateAndTimeForDB: startTime,
          endDateAndTimeForDB: endTime,
          overnight: shift.overnight,
          unpaidBreak: shift.unpaidBreak,
          hasUnpaidBreak: shift.unpaidBreak > 0,
        };
      });

      const warehouse_jobble_type = this.$rootScope.warehouse_jobble_type || {};

      const currentUser = this.$auth.getUserData();
      const rate = currentUser.company.defaultPlan.jobblerFeePct;
      const epi = 0.00001;

      let p = 100 - rate * 100;
      let x = parseFloat(this.event.hourly_rate) * 100;
      let z = x / p;

      const payPerHour = Math.round((z + epi) * 100) / 100;

      if (this.event.numberOfWeeksToScheduleJob === "null") {
        this.event.numberOfWeeksToScheduleJob = null;
      }

      const event = {
        name: this.event.shift_title || "DEFAULT_EVENT_TITLE",
        openings: this.event.openings || 10,
        typeOfJobPosting: "regular",
        dress_code: this.event.dress_code || DRESS_CODE_DEFAULT,
        arrival_instructions: this.event.arrival_instructions,
        onsite_manager_name: this.event.onsite_manager_name,
        onsite_manager_number: this.event.onsite_manager_number,
        isW2: this.event.is_w2,
        timeIntervalsArray,
        jobble_type: parseFloat(this.event.position_type) || warehouse_jobble_type.id || 8,
        manager: this.event.hiring_manager,
        jobble_details: this.event.shift_description,
        hourly_rate: payPerHour,
        is_long_term: this.event.is_long_term,
        weeks: this.event.numberOfWeeksToScheduleJob,
      };

      this.$timeout(() => {
        this.generatingShift = true;
      });

      console.log("clone event payload in PAJ Controller:", event);

      this.$events
        .saveDraftv2(event, this.event.clonedFrom)
        .then((data) => {
          this.$timeout(() => {
            this.generatingShift = false;
          });

          console.log("Created new event from clone in PAJ Controller:", data);

          this.$tracking.reportPostAJobSubmitStep("clone event");
          this.$tracking.reportPostAJobSubmitStep("date & time");

          this.event.id = data.data.jobblePool.eventId;

          //TODO: adding the eventId to the url essentially is reloading the page. Why?

          this.$state.transitionTo("postashiftwalkthrough", {eid: this.event.id}, {notify: false});
          //this.$location.search("eid", this.event.id);
          this.$location.search("cid", null);

          // if (this.event.questions && this.event.questions.length) {
          //     const data = {
          //         event_id: this.event.id,
          //         questions: this.event.questions,
          //     };
          //
          //     this.$events
          //         .updateQuestion(data)
          //         .then((data) => {
          //             console.log("Saved questions for clone:", data);
          //         })
          //         .catch((err) => {
          //             console.error("Error savings questions for clone:", data);
          //         });
          // }

          if (this.event.requirements && this.event.requirements.length) {
            this.$events.addShiftRequirements(this.event.id, this.event.requirements).then((data) => {
              console.log("Saved requirements for clone:", data);
            });
          }

          this.calculateCosts();
          //kkkkkkkk
          if (this.event.is_long_term) {
            this.updateLongTermWeeks(this.event.numberOfWeeksToScheduleJob)
              .then(() => {
                console.log("Done syncing with the API after event cloning in PAJ Controller", this.event);
                this.$timeout(() => {
                  this.setWalkthroughState(WALKTHROUGH_STATES.DATEANDTIME);
                }, 100);
                this.$timeout(() => {
                  this.$rootScope.$emit("PostAJobGlobalApiSyncLongTerm", {event: this.event});
                }, 1000);
              })
              .catch((e) => {
                this.$timeout(() => {
                  this.setWalkthroughState(WALKTHROUGH_STATES.DATEANDTIME);
                }, 1000);
              });
          } else {
            this.$timeout(() => {
              this.setWalkthroughState(WALKTHROUGH_STATES.DATEANDTIME);
            }, 100);
            this.$timeout(() => {
              this.$rootScope.$emit("PostAJobGlobalApiSyncSingleJob", {event: this.event});
            }, 500);
          }
        })
        .catch((err) => {
          console.error("Error creating new event from clone:", err);
        });
    });
  }

  updateLongTermWeeks(weeks) {
    console.log("updateLongTermWeeks in PAJ Controller");
    console.dir(weeks);

    return new Promise((resolve) => {
      this.$timeout(() => {
        this.event.numberOfWeeksToScheduleJob = weeks;
        this.$rootScope.$emit("SetNewWeeksOnChange", this.event);
        if (this.event.id) {
          this.$events
            .saveEventLongTermWeeks(this.event.id, weeks)
            .then((data) => {
              console.log("Updated long term event weeks in PAJ Controller:", data);
              resolve();
            })
            .catch((e) => {
              console.error(e);
              resolve();
            });
        } else {
          resolve();
        }
      });
    });
  }

  setValidStates(setNext) {
    if (!this.event) return null;

    console.log("setValidStates");
    console.dir(setNext);
    //console.log("allowed", JSON.stringify(this.allowed));

    console.log("this.event", this.event, this.event.position_type, !!this.event.position_type);

    let lastValid;

    this.allowed.position_type = true;
    this.valid.position_type = !!this.event.position_type;
    lastValid = WALKTHROUGH_STATES.POSITION;

    this.allowed.location = this.allowed.position_type && this.valid.position_type;
    this.valid.location = (this.event.contactInfo && this.event.contactInfo.lat && this.event.contactInfo.lng) || this.event.remote_job;
    lastValid = this.valid.location && this.allowed.location ? WALKTHROUGH_STATES.LOCATION : lastValid;

    this.allowed.shifts = this.allowed.location && this.valid.location;
    this.valid.shifts = this.validateShifts();
    lastValid = this.valid.shifts && this.allowed.shifts ? WALKTHROUGH_STATES.DATEANDTIME : lastValid;

    this.allowed.openings = this.allowed.shifts && this.valid.shifts;
    this.valid.openings = this.validateOpenings();
    lastValid = this.valid.openings && this.allowed.openings ? WALKTHROUGH_STATES.OPENINGS : lastValid;

    this.allowed.shift_title = this.allowed.openings && this.valid.openings;
    this.valid.shift_title = !!this.event.shift_title;
    lastValid = this.valid.shift_title && this.allowed.shift_title ? WALKTHROUGH_STATES.SHIFT_TITLE : lastValid;

    this.allowed.company_info = this.allowed.shift_title && this.valid.shift_title;
    this.valid.company_info = !!this.event.company_info;
    lastValid = this.valid.company_info && this.allowed.company_info ? WALKTHROUGH_STATES.COMPANY_INFO : lastValid;

    this.allowed.shift_description = this.allowed.company_info && this.valid.company_info;
    this.valid.shift_description = this.validateDescription();
    lastValid = this.valid.shift_description && this.allowed.shift_description ? WALKTHROUGH_STATES.SHIFT_DESCRIPTION : lastValid;

    this.allowed.arrival_instructions = this.allowed.shift_description && this.valid.shift_description;
    this.valid.arrival_instructions = this.validateArrivalInstructions();
    lastValid = this.valid.arrival_instructions && this.allowed.arrival_instructions ? WALKTHROUGH_STATES.ARRIVAL_INSTRUCTIONS : lastValid;

    this.allowed.dress_code = this.allowed.arrival_instructions && this.valid.arrival_instructions;
    this.valid.dress_code = this.validateDressCode();
    lastValid = this.valid.dress_code && this.allowed.dress_code ? WALKTHROUGH_STATES.SUGGESTED_ATTIRE : lastValid;

    this.allowed.requirements = this.allowed.dress_code && this.valid.dress_code;
    this.valid.requirements = this.event.requirements && this.event.requirements.length;
    lastValid = this.valid.requirements && this.allowed.requirements ? WALKTHROUGH_STATES.REQUIREMENTS : lastValid;

    // this.allowed.questions = this.allowed.dress_code && this.valid.dress_code;
    // this.valid.questions = this.event.questions && this.event.questions.length;
    // lastValid = this.valid.questions && this.allowed.questions ? WALKTHROUGH_STATES.QUESTIONS : lastValid;

    // this.allowed.hiring_manager = this.allowed.questions && this.valid.questions;
    this.allowed.hiring_manager = this.allowed.dress_code && this.valid.dress_code;
    this.valid.hiring_manager = this.allowed.hiring_manager && !!this.event.hiring_manager;
    lastValid = this.valid.hiring_manager && this.allowed.hiring_manager ? WALKTHROUGH_STATES.HIRE : lastValid;

    this.allowed.hourly_rate = this.allowed.hiring_manager && this.valid.hiring_manager;
    this.valid.hourly_rate = !!this.event.hourly_rate && this.event.hourly_rate >= 7.25;
    lastValid = this.valid.hourly_rate && this.allowed.hourly_rate ? WALKTHROUGH_STATES.PAY : lastValid;

    this.calculateCosts();

    console.log("this.allowed");
    console.dir(this.allowed);
    console.dir(lastValid);

    if (setNext) {
      this.handleGoNext(lastValid);
    }
  }

  toggleSideBarGroup(index) {
    if (index === 1) this.group1State = !this.group1State;
    else if (index === 2) this.group2State = !this.group2State;
    else if (index === 3) this.group3State = !this.group3State;
  }

  getJobbleTypes() {
    return new Promise((resolve) => {
      this.$auth.getJobbleTypes().then((data) => {
        this.$timeout(() => {
          this.jobble_types = data.data;
          this.$rootScope.jobble_types = data.data;
          resolve(data.data);
        });
      });
    });
  }

  getCompanyUsers() {
    this.$companies.getCompanyUsers().then(
      (response) => {
        this.constructOptions(response.data);
      },
      (error) => {}
    );
  }

  constructOptions(users) {
    let user_array = [];

    users.forEach((user) => {
      let user_map = {};

      if (user.homeContactInfo.phoneMobile) {
        user_map.firstName = user.firstName;
        user_map.lastName = user.firstName;
        user_map.phone = user.homeContactInfo.phoneMobile;
        user_map.id = user.id;
        user_map.str = user.firstName + " " + user.lastName;
        user_map.email = user.email;
        user_array.push(user_map);
      } else {
        user.homeContactInfo.phoneMobile = "--";
        user_map.firstName = user.firstName;
        user_map.lastName = user.firstName;
        user_map.phone = user.homeContactInfo.phoneMobile;
        user_map.id = user.id;
        user_map.str = user.firstName + " " + user.lastName;
        user_map.email = user.email;
        user_array.push(user_map);
      }
    });

    this.$rootScope.hiring_managers = user_array;
  }

  findWarehouseJobType(types) {
    let type = null;

    if (!types || !types.length) return type;

    types.forEach((t) => {
      const name = t.name.toLowerCase();
      if (name.indexOf("warehouse") !== -1) type = t;
    });

    return type;
  }

  findRemoteJobType(types) {
    let type = null;

    if (!types || !types.length) return type;

    types.forEach((t) => {
      const name = t.name.toLowerCase();
      if (name.indexOf("remote") !== -1) type = t;
    });

    return type;
  }

  findEventJobType(types) {
    let type = null;

    if (!types || !types.length) return type;

    types.forEach((t) => {
      const name = t.name.toLowerCase();
      if (name.indexOf("event") !== -1) type = t;
    });

    return type;
  }

  handleGoNext(prevState) {
    //this.setValidStates();

    let nextState = prevState;

    switch (prevState) {
      case WALKTHROUGH_STATES.POSITION:
        nextState = WALKTHROUGH_STATES.LOCATION;
        break;
      case WALKTHROUGH_STATES.LOCATION:
        nextState = WALKTHROUGH_STATES.DATEANDTIME;
        break;
      case WALKTHROUGH_STATES.DATEANDTIME:
        nextState = WALKTHROUGH_STATES.OPENINGS;
        break;
      case WALKTHROUGH_STATES.OPENINGS:
        nextState = WALKTHROUGH_STATES.SHIFT_TITLE;
        break;
      case WALKTHROUGH_STATES.SHIFT_TITLE:
        nextState = WALKTHROUGH_STATES.COMPANY_INFO;
        break;
      case WALKTHROUGH_STATES.COMPANY_INFO:
        nextState = WALKTHROUGH_STATES.SHIFT_DESCRIPTION;
        break;
      case WALKTHROUGH_STATES.SHIFT_DESCRIPTION:
        nextState = WALKTHROUGH_STATES.ARRIVAL_INSTRUCTIONS;
        break;
      case WALKTHROUGH_STATES.ARRIVAL_INSTRUCTIONS:
        nextState = WALKTHROUGH_STATES.SUGGESTED_ATTIRE;
        break;
      case WALKTHROUGH_STATES.SUGGESTED_ATTIRE:
        nextState = WALKTHROUGH_STATES.REQUIREMENTS;
        break;
      case WALKTHROUGH_STATES.REQUIREMENTS:
        nextState = WALKTHROUGH_STATES.HIRE;
        break;
      // case WALKTHROUGH_STATES.QUESTIONS:
      //     nextState = WALKTHROUGH_STATES.HIRE;
      //     break;
      case WALKTHROUGH_STATES.HIRE:
        nextState = WALKTHROUGH_STATES.PAY;
        break;
    }

    this.setWalkthroughState(nextState);
  }

  setWalkthroughState(state) {
    console.log("setWalkthroughState");
    console.dir(state);
    this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});
    this.$timeout(() => {
      this.walkthroughState = state;
      if (state === 20) {
      }
      if (state === 1) {
        this.$rootScope.$emit("DoNotTriggerModal", {});
      }
      document.getElementById("paj-main-scroll").scrollTop = 0;
    });
  }

  getNewShiftObject() {
    return null;

    return {
      startDate: null, //"08/21/2020",
      endDate: null, //"08/21/2020",
      startTime: null, //"8:00",
      endTime: null, //"21:00",
      overnight: false,
    };
  }

  validateOpenings() {
    if (!this.event || !this.event.openings) return false;

    return this.event.openings <= 1000 && this.event.openings > 0;
  }

  validateDescription() {
    if (!this.event || !this.event.shift_description) return false;

    return this.event.shift_description.length <= 1000;
  }

  validateArrivalInstructions() {
    if (!this.event || !this.event.arrival_instructions) return false;
    if (!this.event.onsite_manager_number) return false;
    if (!this.event.onsite_manager_name) return false;

    return this.event.arrival_instructions.length <= 500;
  }

  validateDressCode() {
    if (!this.event || !this.event.dress_code) return false;

    return this.event.dress_code.length <= 500;
  }

  validateShifts() {
    let allValid = true;
    if (!this.event || !this.event.shifts || !this.event.shifts.length) {
      allValid = false;
      return allValid;
    }

    this.event.shifts.forEach((shift) => {
      let valid = this.$events.validateWorflowShift(shift);

      if (shift && shift.startDate) {
        const startDate = new Date(`${shift.startDate} ${shift.startTime}`);
        if (this.development_env !== "dev" && startDate.getTime() - new Date().getTime() <= GRACE_PERIOD) {
          console.error("Start date is less than 3 days from now");
          valid = false;
        }
      }

      if (!valid) allValid = false;

      return valid;
    });

    if (allValid) {
      if (!this.$events.validateWorflowShiftsNonOverlapping(this.event.shifts)) {
        allValid = false;
      }
    }

    return allValid;
  }
}

PostAShiftWalkThroughController.$inject = [
  "$localStorage",
  "$scope",
  "$rootScope",
  "$state",
  "$stateParams",
  "auth",
  "env",
  "security",
  "$timeout",
  "tracking",
  "events",
  "ngProgressFactory",
  "$location",
  "companies",
];

export default PostAShiftWalkThroughController;



// WEBPACK FOOTER //
// ./client/app/scenes/postashiftwalkthrough/postashiftwalkthrough.controller.js